import React, { useEffect } from 'react';
import { useGlobalContext } from '../../components/GlobalContextProvider/GlobalContextProvider';
import Header from '../../components/Header/Header';
import {
  GradientContainer,
  Message,
  HomeButton,
  SmallMessage,
} from '../../shared-styled/blocks/errorPagesBlocks';
import {
  BasePageContainer,
  ChildrenWrapper,
} from '../BasePage/BasePage.styled';
import NavigationPage from '../NavigationPage/NavigationPage';

const Page503 = () => {
  const { isNavActive } = useGlobalContext();

  const reloadPage = () => {
    window.location.reload();
  };

  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'pageView',
      componentName: 'Page503',
    });
  }, []);

  return (
    <BasePageContainer>
      <Header />
      {isNavActive ? (
        <NavigationPage isNotFoundPage={true} />
      ) : (
        <ChildrenWrapper>
          <GradientContainer>
            <Message>503</Message>
            <SmallMessage>{`Service Unavailable `}</SmallMessage>
            <HomeButton onClick={reloadPage}>Try to reload page</HomeButton>
          </GradientContainer>
        </ChildrenWrapper>
      )}
    </BasePageContainer>
  );
};

export default Page503;
